var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"dashboard-analytics"},on:{"~load":function($event){return _vm.refreshPage()}}},[_c('div'),_c('div',{staticClass:"w-full md:flex-col lg:flex-row xl:flex-row flex",staticStyle:{"flex-direction":"column"}},[_c('FastAccess')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }